<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fa fa-users"></i> Mapeamento de Grupos AD → Permissões NxCoop</h3>
        <small>Configuração de mapeamento entre grupos do Active Directory e permissões do sistema.</small>
      </div>
    </div>

    <ModeloList ref="ModeloList" v-on:New="onNew" v-on:Edit="onEdit" />

    <!-- Modal para Adicionar/Editar -->
    <b-modal
      v-model="showModal"
      :title="editMode ? 'Editar Mapeamento de Grupo AD' : 'Novo Mapeamento de Grupo AD'"
      size="lg"
      hide-footer
      @hidden="onModalHidden"
    >
      <ModeloAdd
        ref="ModeloAdd"
        :isModal="true"
        v-on:Back="onCloseModal"
      />
    </b-modal>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import ModeloAdd from './components/add/GroupMappingsAdd.vue'
import ModeloList from './components/list/GroupMappingsList.vue'

export default {
  name: 'GroupMappings',
  data () {
    return {
      showModal: false,
      editMode: false
    }
  },
  components: {
    ModeloAdd,
    ModeloList
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  mounted () {
    Tools.MinimizedSidebar()
  },
  methods: {
    onLoad () {},
    onNew () {
      this.editMode = false
      this.showModal = true
      this.$nextTick(() => {
        if (this.$refs.ModeloAdd) {
          this.$refs.ModeloAdd.onClear()
        }
      })
    },
    onEdit (obj) {
      this.editMode = true
      this.showModal = true
      this.$nextTick(() => {
        if (this.$refs.ModeloAdd) {
          this.$refs.ModeloAdd.onEdit(obj)
        }
      })
    },
    onCloseModal () {
      this.showModal = false
    },
    onModalHidden () {
      // Recarregar dados da grade quando o modal for fechado
      if (this.$refs.ModeloList) {
        this.$nextTick(() => {
          this.$refs.ModeloList.onLoad()
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ADSync/GroupMappings.vue